import React from "react";
import { OfferStatus } from "../../helpers/bidderHelper";

/*
    - Gris: pas d'offre encodée
    - Vert clair : offre reçue et validée
    - Vert foncé : sélectionné (lauréat)
    - Rouge: rejeté
 */
export default function BidderStatusDot({ status, title = "", size = "lg" }) {
  const sizeClass = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  }[size] || "w-4 h-4";

  const colorClass = (() => {
    if (status === OfferStatus.SELECTED) return "bg-green-600";
    if (status === OfferStatus.REJECTED) return "bg-red-500";
    if (status === OfferStatus.ANSWERED) return "bg-green-200";
    return "bg-gray-300";
  })();

  return (
    <span
      title={title}
      className={`inline-block rounded-full ${sizeClass} ${colorClass} flex-shrink-0`}
      aria-hidden="true"
    />
  );
}
